export function initGiftVipModal() {
    let packageType = '';

    $('[data-toggle="tooltip"]').tooltip();

    $('[data-toggle="modal"][data-target="#giftVIPModal"]').click(function () {
        packageType = $(this).data('package');
        $('#gift-vip-form input[name="product"]').val(packageType);
        $('#gifting-vip-package-name').text(packageType.replace('_', ' '));
    });

    $("#gift-vip-form").submit(handleGiftVipFormSubmit);

    $('#giftVIPModal').on('hidden.bs.modal', function (e) {
        $("#giftVIPModal #confirm-checkbox").prop('checked', false);
        $("#giftVIPModal #gift-vip-form #username").val("");
        $("#giftVIPModal #gifting-alert-messages").empty();
        $("#giftVIPModal #gift-vip-form #confirmation-section").hide();
    });
}

function handleGiftVipFormSubmit(event) {
    event.preventDefault();
    $("#gifting-alert-messages").empty();

    let formData = $(this).serialize();
    const url = window.giftVipStoreUrl;

    if ($("#confirm-checkbox").is(":checked")) {
        formData = $(this).serialize() + "&confirm=true";
    }

    $.ajax({
        type: "POST",
        url: url,
        data: formData,
        dataType: "json",
        success: handleGiftVipAjaxSuccess,
        error: handleGiftVipAjaxError
    });
}

function handleGiftVipAjaxSuccess(response) {
    if (response.needConfirmation) {
        $("#giftVIPModal #confirmation-details").html(`<span class="font-weight-bold">Username:</span> ${response.username}<br/> <span class="font-weight-bold">VIP Rank:</span> ${response.productName}<br/> <span class="font-weight-bold">Price:</span> &pound;${response.price}`);
        $("#giftVIPModal #confirmation-section").show();
    } else {
        $("#giftVIPModal #gift-vip-form #confirmation-section").hide();
        $('#giftVIPModal #confirm-checkbox').prop('checked', false);
        $("#giftVIPModal #gift-vip-form #username").val("");
    }

    const successAlert = `<div class="alert alert-success" role="alert">${response.success}</div>`;
    $("#giftVIPModal #gifting-alert-messages").html(successAlert);
}

function handleGiftVipAjaxError(xhr) {
    const errorMessage = xhr.responseJSON.error;
    if (errorMessage) {
        const errorAlert = `<div class="alert alert-danger" role="alert">${errorMessage}</div>`;
        $("#gifting-alert-messages").html(errorAlert);
    }
}